<div class="item-page-field">
  <ds-metadata-values
    [mdValues]="item?.allMetadata(fields)"
    [separator]="separator"
    [label]="label"
    [enableMarkdown]="enableMarkdown"
  ></ds-metadata-values>
</div>
